import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import type { Button } from '@xing-com/button';
import { addParams } from '@xing-com/xing-tracking';

import * as Styled from './login-button.styled';

export type LoginButtonProps = {
  loginLink: string | undefined;
};

const ButtonSmallWhenTopBar: React.FC<
  Omit<React.ComponentProps<typeof Button>, 'size'>
> = (props) => {
  return (
    <>
      <Styled.ButtonSmallWhenTopBar {...props} $size="small" size="small" />
      <Styled.ButtonSmallWhenTopBar {...props} $size="medium" size="medium" />
    </>
  );
};

export const LoginButton: React.FC<LoginButtonProps> = ({ loginLink }) => {
  const [loginButtonTo, setLoginButtonTo] = useState<string | undefined>(
    undefined
  );
  const { formatMessage } = useIntl();

  const trackingUrl =
    loginLink && addParams(loginLink, { nwt_nav: 'sign_up_button' });

  useEffect(() => {
    setLoginButtonTo(trackingUrl);
  }, [trackingUrl]);

  return (
    <ButtonSmallWhenTopBar
      data-testid="styled-Login-Button"
      to={loginButtonTo}
      href={loginLink}
      variant="primary"
      // @ts-expect-error FIXME: SC6
      size="large"
    >
      {formatMessage({
        id: 'MAINNAV_LOGIN',
      })}
    </ButtonSmallWhenTopBar>
  );
};
